export default __webpack_public_path__ + "static/media/tieBack.d6534c0c.jpg";